var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2851_7535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6278 11.3186H11.0979V17.5836C11.0979 18.1375 11.3179 18.6684 11.7096 19.06C12.1012 19.4521 12.6324 19.6718 13.1862 19.6718C15.5038 19.6718 19.2219 19.6718 21.5394 19.6718C22.0933 19.6718 22.6245 19.4521 23.0161 19.06C23.4077 18.6684 23.6277 18.1375 23.6277 17.5836C23.6278 15.1094 23.6278 11.3186 23.6278 11.3186Z",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3186 15.4951H16.3187C16.5957 15.7724 16.9712 15.9279 17.3627 15.9279C17.7543 15.9279 18.1298 15.7723 18.4067 15.4951C18.4068 15.4951 18.4068 15.4951 18.4068 15.4951",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4511 19.6719H15.2744V23.8485C15.2744 24.4024 15.4944 24.9334 15.8861 25.325C16.2777 25.717 16.8089 25.9368 17.3627 25.9368C17.9166 25.9368 18.4478 25.717 18.8393 25.325C19.231 24.9334 19.451 24.4024 19.451 23.8485C19.4511 22.0265 19.4511 19.6719 19.4511 19.6719Z",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6278 23.8484H19.4511C19.4511 25.0017 18.5161 25.9367 17.3629 25.9367C17.3625 25.9367 17.3622 25.9367 17.3618 25.9367C16.209 25.9367 15.2746 25.0022 15.2746 23.8494C15.2746 23.8489 15.2746 23.8484 15.2746 23.8484H11.0979V33.2458H23.6278V23.8484Z",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0978 23.8484H9.00954C6.70282 23.8484 4.83289 25.7185 4.83289 28.025C4.83289 30.5347 4.83289 33.2458 4.83289 33.2458H11.0978V23.8484Z",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6277 23.8484H25.716C28.0227 23.8484 29.8926 25.7185 29.8926 28.025C29.8926 30.5347 29.8926 33.2458 29.8926 33.2458H23.6277V23.8484Z",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0979 11.3186H9.00956C7.85626 11.3186 6.92126 12.2537 6.92126 13.4069C6.92126 14.5601 7.85626 15.4952 9.00956 15.4952H11.0979V11.3186Z",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6277 11.3186H25.716C26.8693 11.3186 27.8043 12.2537 27.8043 13.4069C27.8043 14.5601 26.8693 15.4952 25.716 15.4952H23.6277V11.3186Z",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2744 6.0978V1.92114H19.451V6.0978",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4511 6.09785V3.22852C23.0538 4.15572 25.716 7.42655 25.716 11.3186H9.00952C9.00952 7.42649 11.6717 4.15572 15.2745 3.22852V6.09785",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96533 11.3186H26.7602",
    stroke: "black",
    strokeWidth: 1.94967,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2851_7535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.2744,
    height: 33.2744,
    fill: "white",
    transform: "translate(0.725586 0.946289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRequestIcon);
export default __webpack_public_path__ + "static/media/service-request-icon.54f377c12cb460f29c197cab25c2b99f.svg";
export { ForwardRef as ReactComponent };